// 글꼴은 이 한 경로로만 불러온다(자체 호스팅). CDN · CSS @import 를 함께 쓰지 않는다.
import 'pretendard/dist/web/static/pretendard-dynamic-subset.css';
import '@app/styles/index.css';
// env 를 불러오는 순간 환경변수를 검증한다. 틀리면 여기서 멈춘다.
import '@shared/config';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@app/app.ui';
import { startBoot } from '@app/boot/start-boot';

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');

// 세션 복원은 첫 render 전에 시작한다.
startBoot();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
